<script lang="ts">
  import BaseButton from '../BaseButton/BaseButton.svelte';
  import type { ButtonProps } from './types';
  const { ...props }: ButtonProps = $props();
</script>

<BaseButton {...props} />
